import { useTranslation } from "react-i18next";
import { useEffect, useState, useRef, useContext } from "react";
import { useSearchParams } from "react-router-dom";

import axiApi from "ApiCaller";
import AuthContext from "context/AuthContext";
import TopBarActions from "components/TopBarActions";
import TableAssetContainerManager from "./containers/TableAssetContainerManager";
import PrevAssetContainer from "./containers/PrevAssetContainer";
import FormContainerManager from "./containers/FormContainerManager";
import NavBreadcrumb from "components/NavBreadcrum";
import ButtonsActions from "views/utils/buttonsActions";
import { SwalAlertChoice, SwalAlertClass } from "core/swalClass";
import { Asset } from "site-apps/assets/AssetModels";
import { toLowCaseCleanSpaces } from "core/utils/Texts";
import BoxFiltersContainersManager from "./containers/BoxFiltersContainersManager";
import navs from "./navs";
import navsBridge from "./navsBridge";
import ModalModMassive from "./containers/ModalModMassive";
import LoaderSpinner from "context/LoaderSpinner";
import FilterModel from "components/FilterModel";
import TopBarPagination from "components/paginator/TopBarPagination-v2";
import { PagerModel } from "components/paginator/PaginationModel";
import ItemsModel from "core/itemsModel";
import { translations } from "./translations";
import useCustomTranslation from "core/customTranslation";
import ConditionalRender from "components/ConditionalRender";
import OrderingModel from "components/ordering/OrderingModel";

const ViewContainers = () => {
    // Usuario  navs//
    const { user, panel } = useContext(AuthContext);
    const [refreshData, setRefreshData] = useState(0);
    // Translations //
    const { t: _Tr } = useTranslation("routes");
    const { t: _Tt } = useTranslation("tables");
    const { t: _Tc } = useCustomTranslation(translations);

    const bread = [
        {
            name: _Tr("labels.asset-management"),
            url: "/asset-management/",
            current: false,
        },
        { name: panel.panel_type == "w" ? _Tr("labels.containers") : _Tr("labels.bridges"), current: true },
    ];
    const Alert = new SwalAlertClass({ confirmButtonText: "Aceptar" });
    const AlertQuestion = new SwalAlertChoice({
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
    });

    const items = useRef(new ItemsModel());
    // ASSETS //
    const [item, setItem] = useState({ ...Asset });
    const [itemsShow, setItemsShow] = useState([]);
    const [add, setAdd] = useState(false);
    // -
    document.title = panel.panel_type == "w" ? _Tr("labels.containers") : _Tr("labels.bridges");
    const paramsTypes = useRef({});
    const [filtersParams, setFiltersParams] = useState({ groups: [], routes: [] });
    const [showPrev, setShowPrev] = useState(false);
    const [showOffCanvas, setShowOffCanvas] = useState(false);
    const [showOffCanvasEdit, setShowOffCanvasEdit] = useState(false);
    const [showModalMassive, setShowModalMassive] = useState(false);
    const [btnDelete, setBtnDelete] = useState(false);
    const [titleForm] = useState();
    const [buttonsTB, setButtonsTB] = useState(() => {
        const buttonsAct = new ButtonsActions();
        buttonsAct.title = document.title;
        return buttonsAct;
    });
    const [urlQuery] = useSearchParams();
    const filters = useRef(new FilterModel());
    const pagerModelRef = useRef(new PagerModel());
    const [isLoading, setIsLoading] = useState(false);
    const [checkedAll, setCheckedAll] = useState(false);
    const orderingRef = useRef(new OrderingModel());

    useEffect(() => {
        setIsLoading(true);
        // Determinar si el usuario tiene permisos de edición
        const canEdit = user.is_superuser || user.is_admin;

        /*items.current.reset();
        setShowPrev(false);
        setShowOffCanvas(false);*/

        const buttons = { ...buttonsTB };
        buttons.title = document.title;
        //buttons.add.active = true;
        //buttons.add.onClick = onClickAdd;

        // Configurar botón de edición - permitido para todos
        buttons.edit.active = true;
        buttons.edit.disabled = true;
        buttons.edit.onClick = onClickEdit;

        // Configurar botón de eliminación - Solo admin
        buttons.delete.active = canEdit;
        buttons.delete.disabled = true;
        buttons.delete.onClick = onClickDelete;

        // Filtrado disponible para todos
        buttons.filter.active = true;
        buttons.filter.disabled = false;
        buttons.filter.onClick = onClickFilter;
        setButtonsTB(buttons);

        // Pager model
        pagerModelRef.current.active = true;
        pagerModelRef.current.handleCallApi = () => applyFilters();
        orderingRef.current.applyOrder = () => applyFilters();
        items.current.setItem = setItem;
        items.current.setShowPrev = setShowPrev;
        items.current.item = Asset;

        firstFetchContainers();
    }, []);

    useEffect(() => {
        if (refreshData === 1) {
            applyFilters();
            setRefreshData(0);
        }
    }, [refreshData]);

    filters.current.filter = () => {
        pagerModelRef.current.paging.page = 1;
        const buttons = { ...buttonsTB };
        buttons.filter.applied = true;
        setButtonsTB(buttons);
        applyFilters();
    };

    const onClickEdit = () => {
        if (items.current.chosen.length === 0) {
            const buttons = { ...buttonsTB };
            buttons.edit.disabled = true;
            buttons.delete.disabled = true;
            setButtonsTB(buttons);
            return false;
        }
        if (items.current.chosen.length > 1) {
            setShowModalMassive(true);
            return;
        }
        let asset = items.current.chosen[0];

        axiApi
            .get(`/api/assets/asset/${asset}/`)
            .then((resp) => {
                if (resp.data.status) {
                    let asset = resp.data.item;
                    asset.idx = items.current.chosen[0];
                    setItem(asset);
                    setAdd(false);
                    setShowOffCanvas(true);
                    setShowOffCanvasEdit(true);
                } else {
                    Alert.error(_Tc("alert.edit.error"), _Tc("alert.recovery.asset"));
                }
            })
            .catch((error) => {
                Alert.error(_Tc("notify.admin"), _Tc("alert.recovery.asset"));
                console.log(error);
            });
    };

    const onClickDelete = () => {
        const selectedIds = items.current.getChosenUuids();
        AlertQuestion.warning(_Tc("alert.delete"), `Se borraran los ${selectedIds.length} contenedores seleccionados`).then(
            (result) => {
                if (result.isConfirmed) {
                    axiApi
                        .post(`/api/assets/delete/`, {
                            uid: selectedIds,
                        })
                        .then((resp) => {
                            if (resp.status === 200) {
                                Alert.success(_Tc("alert.delete.success"), resp.data.message);
                                fetchContainers();
                            }
                        })
                        .catch((error) => {
                            console.error("Error al enviar la solicitud:", error);
                        })
                        .finally(() => {
                            setIsLoading(false);
                            items.current.clearChosen();
                            const buttons = { ...buttonsTB };
                            buttons.edit.disabled = true;
                            buttons.delete.disabled = true;
                            setButtonsTB(buttons);
                            setCheckedAll(false);
                            setShowPrev(false);
                        });
                }
            },
        );
    };

    const onClickFilter = () => {
        const buttons = { ...buttonsTB };
        buttons.filter.click = !buttonsTB.filter.click;
        setButtonsTB(buttons);
    };

    const urlQueryParams = () => {
        if (urlQuery.has("uid")) {
            let uid = urlQuery.get("uid");
            filters.current.searcher.ref.value = uid;
            filters.current.chosen.searcher = toLowCaseCleanSpaces(uid);
            filters.current.filter();
            axiApi
                .get(`/api/assets/asset/${uid}/`)
                .then((resp) => {
                    if (resp.data.status) {
                        let asset = resp.data.item;
                        asset.idx = uid;
                        setItem(asset);
                        setAdd(false);
                        setShowOffCanvas(true);
                        setShowOffCanvasEdit(true);
                    }
                })
                .catch((error) => console.log(error));
        }
    };

    const firstFetchContainers = async () => {
        setIsLoading(true);

        try {
            const resp = await axiApi.get("/api/assets/");
            // console.log(resp);
            if (resp.data) {
                items.current.showed = [...resp.data.items];
                setItemsShow(items.current.showed);
                pagerModelRef.current.paging.setPager(resp.data);

                setFiltersParams({
                    groups: resp.data.params.groups || [],
                    routes: resp.data.params.routes || [],
                });
                urlQueryParams();
            }
        } catch (error) {
            console.error("error:", error);
            const buttons = { ...buttonsTB };
            buttons.filter.applied = false;
            setButtonsTB(buttons);
        } finally {
            setIsLoading(false);
        }
    };

    const fetchContainers = async () => {
        setIsLoading(true);
        try {
            const resp = await axiApi.get("/api/assets/", filters.current.chosen, {
                params: { ...pagerModelRef.current.paging.getParams(), ...orderingRef.current.getParams() },
            });

            if (resp.data) {
                items.current.setShowed(resp.data.items);
                setItemsShow([...resp.data.items]);
                pagerModelRef.current.paging.setPager(resp.data);
            }
        } catch (error) {
            console.error("error:", error);
            const buttons = { ...buttonsTB };
            buttons.filter.applied = false;
            setButtonsTB(buttons);
        } finally {
            setIsLoading(false);
        }
    };

    const applyFilters = () => {
        setIsLoading(true);
        axiApi
            .post("/api/assets/", filters.current.chosen, {
                params: { ...pagerModelRef.current.paging.getParams(), ...orderingRef.current.getParams() },
            })
            .then((resp) => {
                items.current.setShowed(resp.data.items);
                setItemsShow([...resp.data.items]);
                if (resp.data.pager) {
                    pagerModelRef.current.active = true;
                    pagerModelRef.current.paging.update(resp.data.pager);
                }
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    return (
        <>
            {panel.panel_type === "w" ? (
                <NavBreadcrumb navs={navs} bread={bread} />
            ) : (
                <NavBreadcrumb navs={navsBridge} bread={bread} />
            )}

            <TopBarActions actions={buttonsTB} filtersRef={filters} />
            <BoxFiltersContainersManager show={buttonsTB.filter.click} filters={filters.current} filtersParams={filtersParams} />
            <TopBarPagination pagerModel={pagerModelRef.current} stickyTopValue="125px" chosen={items.current.chosen} />
            <div className="row">
                <div className="col-md col-12">
                    <LoaderSpinner isLoading={isLoading}>
                        <TableAssetContainerManager
                            itemsShow={itemsShow}
                            items={items}
                            checkAll={checkedAll}
                            setCheckAll={setCheckedAll}
                            buttonsTB={buttonsTB}
                            setButtonsTB={setButtonsTB}
                            orderingRef={orderingRef}
                        />
                    </LoaderSpinner>
                </div>
                {items.current.chosen.length === 1 ? (
                    <ConditionalRender condition={showPrev}>
                        <div className="col-md col-12 prev-item" style={{ maxWidth: "300px" }}>
                            <PrevAssetContainer asset={item} showPreview={showPrev} />
                        </div>
                    </ConditionalRender>
                ) : (
                    <></>
                )}
            </div>
            <ConditionalRender condition={showOffCanvas}>
                <FormContainerManager
                    title={titleForm}
                    itemsShow={items.current.showed}
                    setItemsShow={setItemsShow}
                    item={item}
                    setItem={setItem}
                    add={add}
                    paramsTypes={paramsTypes}
                    setShow={setShowOffCanvas}
                    show={showOffCanvas}
                    setPrev={setShowPrev}
                    setShowCanvasEdit={setShowOffCanvasEdit}
                    showCanvasEdit={showOffCanvasEdit}
                    buttons={buttonsTB}
                    btnDelete={btnDelete}
                    setBtnDelete={setBtnDelete}
                    setRefreshData={setRefreshData}
                    items={items}
                />
            </ConditionalRender>
            <ConditionalRender condition={showModalMassive}>
                <ModalModMassive
                    show={showModalMassive}
                    setShow={setShowModalMassive}
                    items={items}
                    setItemsShow={setItemsShow}
                    firstFetchContainers={firstFetchContainers}
                />
            </ConditionalRender>
        </>
    );
};
export default ViewContainers;